import { select, Store } from '@ngneat/elf';
import { Injectable } from '@angular/core';
import { DynamicFieldProps, dynamicFieldInitialState } from './dynamic-field.store';
import { BaseStoreRepository } from '../../base-store.repository';
import { DynamicField } from '@/types';

export type DynamicFieldStore = Store<
  {
    name: string;
    state: DynamicFieldProps;
    config: undefined;
  },
  DynamicFieldProps
>;

@Injectable({ providedIn: 'root' })
export class DynamicFieldRepositoryFactory {
  static create(store: DynamicFieldStore) {
    return new DynamicFieldRepository(store);
  }
}

export class DynamicFieldRepository extends BaseStoreRepository<DynamicFieldProps> {
  constructor(store: DynamicFieldStore) {
    super(store.pipe(select(state => state)), store, { ...dynamicFieldInitialState });
  }

  setDynamicFieldDto(response: DynamicField): void {
    this.set('dto', {
      dynaFormFieldsId: response.dynaFormFieldsId || null,
      status: response.status,
      name: response.name,
      label: response.label,
      description: response.description,
      type: response.type,
      isRequired: response.isRequired,
      order: response.order,
      hasTotal: response.hasTotal,
      isFormula: response.isFormula,
      formula: response.formula,
    });
    this.set('typeSelected', { name: response.type, code: response.type });
  }
}
